module.exports = __webpack_public_path__ + "img/prize4.869e411f.png";